import { Component, OnInit } from '@angular/core';
import { QuestionProcessingService } from "../services/question-processing.service";
import { ProgressBar } from "./ProgressBar";
import { timer } from 'rxjs/observable/timer';
import { TouchEventService } from '../services/touch-event.service';
import { Question, WOTCCategory } from './dennysFlow';
import { Router } from '@angular/router';
import { DisplayLanguage } from './DisplayLanguage';

export class BaseComponent implements OnInit{
  category: WOTCCategory;
  currentQuestion : Question;
  questionPart : number = 0;
  validationError: boolean;
  public questions: QuestionProcessingService;
  isMobileDevice: boolean = false;
  progressTracker : ProgressBar;
  percentageComplete: number = 0

  constructor(public swiper : TouchEventService, public location : Router) {
    this.progressTracker  = new ProgressBar();
    this.swiper.publisher.subscribe((args: any) => {
      // console.log('swiping in direction : ', args);
      if(args == 'next')this.continue();
      else this.back();
    });
    if (window.innerWidth < 710) this.isMobileDevice = true;
  }

  ngOnInit(): void {
    document.getElementsByClassName('container')[0].classList.remove('slide-backward');
    document.getElementsByClassName('container')[0].classList.add('slide-forward');
    var tim = timer(0);
    tim.subscribe(t => {
      document.getElementsByClassName('container')[0].classList.remove('slide-forward');
    })

    if(this.questions.forward)
    // Setup the progress bar
      this.initLoader();
  }

  public get question_list() : Array<Question> {
    return this.questions.Questions.filter(q => q.Category == this.category);
  }

  setPercentComplete(){
    var qsToShow = this.question_list.filter((q)=>{return q.show()}).length;
    var qsToShowAnswered = this.question_list.filter((q)=>{return q.show() && q.Answered}).length;

    this.percentageComplete= (qsToShowAnswered/qsToShow) * 100
    this.setProgress();
  }

  continue(segment:string = null) {
   console.log('base called continue')
   console.log(this.questions.language);
    this.questions.forward = true;
    // check to see if there is another question we can move to?
    var nexQuestion = this.question_list[this.question_list.indexOf(this.currentQuestion) + 1];
    if(nexQuestion && nexQuestion.show()) {
      this.currentQuestion = nexQuestion;
      this.SetVerbiage(this.questions.language, this.currentQuestion);
    }
    else {
      if(segment)this.location.navigateByUrl(segment);
    }
  }

  back(segment:string = null){
    this.questions.forward = false;
    // show the last question answered?
    if(this.currentQuestion == this.question_list[0]){
      if(segment)this.location.navigateByUrl(segment); 
      else console.log('at the beginning');
      return;
    } 

    // this.question_list[this.question_list.indexOf(this.currentQuestion) -1]
    // need to go back to the last question that should be shown()
    var nexQ = this.question_list[this.question_list.indexOf(this.currentQuestion) -1];
    while(nexQ && !nexQ.show()){
      nexQ = this.question_list[this.question_list.indexOf(nexQ) -1]
    }
    this.currentQuestion = nexQ;
  }

  public get validationMessage(): string {
    return this.questions.SelectVerbiage('Buttons')[2].Verbiage;
      
  }

  public get buttonMessage(): string {
    return this.questions.SelectVerbiage('Buttons')[0].Verbiage;
  }

  public get buttonMessageBack(): string {
    return this.questions.SelectVerbiage('Buttons')[1].Verbiage;
  }
  
  help() : void {
    console.log('HELP');
  }

  setupQuestion(): void {
    // if all our questions are answered then we should start with the last one and move back
    console.log(this.questions.forward);
    if (this.questions.forward) { // if all our questions are answered (and we are moving backward)then we should start with the last one and move back
      this.currentQuestion = this.question_list.filter((a) => {
        return a.show()
      })[0];
    } else {
      if (this.question_list.filter((a) => {
        return a.show()
      }).length == this.question_list.length) {
        this.currentQuestion = this.question_list[this.question_list.length - 1];
      } else { // otherwise this is the first encounter 
        this.currentQuestion = this.question_list[0];
      }
    }
    
    this.currentQuestion.Answer = this.currentQuestion.Get(); // for input components we need to get hte Answer prop updated from model.
  }

  
  toggleLoader() {
    document.getElementsByClassName('circle')[0].classList.remove('checkmark__circle__red');
    document.getElementsByClassName('circle')[0].classList.remove('checkmark__circle__orange');
    document.getElementsByClassName('circle')[0].classList.remove('checkmark__circle__yellow');
    document.getElementsByClassName('circle')[0].classList.remove('checkmark__circle__yellowish');
    document.getElementsByClassName('circle')[0].classList.remove('checkmark__circle__green');

    document.getElementsByClassName('checkmark')[0].classList.remove('checkmark__fill__red');
    document.getElementsByClassName('checkmark')[0].classList.remove('checkmark__fill__orange');
    document.getElementsByClassName('checkmark')[0].classList.remove('checkmark__fill__yellow');
    document.getElementsByClassName('checkmark')[0].classList.remove('checkmark__fill__yellowish');
    document.getElementsByClassName('checkmark')[0].classList.remove('checkmark__fill__green');
    document.getElementsByClassName('check')[0].classList.remove('checkmark__check');
    
    setTimeout(() => {
      document.getElementsByClassName('circle')[0].classList.add(this.progressTracker.circleClass);
      document.getElementsByClassName('checkmark')[0].classList.add(this.progressTracker.checkClass);
      document.getElementsByClassName('check')[0].classList.add('checkmark__check');
    }, 300);

  }

  initLoader() {
    setTimeout(() => {
      document.getElementsByClassName('circle')[0].classList.add('checkmark__circle__red');
      document.getElementsByClassName('checkmark')[0].classList.add('checkmark__fill__red');
      document.getElementsByClassName('check')[0].classList.add('checkmark__check');
    }, 200);
  }

  SetVerbiage(lang: DisplayLanguage, q : Question) {
    //set the language
    switch(lang) {
      case 0:
        q.Verbiage = q.Verbiage.filter((v) => { return v.Language == DisplayLanguage.ENGLISH })
        break;
      case 1:
        q.Verbiage = q.Verbiage.filter((v) => { return v.Language == DisplayLanguage.SPANISH })
        break;
      default:
        break;
    }
  }

  private setProgress(){
    let holder: string = "";
    if(this.percentageComplete <= 10) holder = "red";
    if(this.percentageComplete >= 10 && this.percentageComplete <= 40) holder = "orange";
    if(this.percentageComplete >= 40 && this.percentageComplete <= 80) holder = "yellow";
    if(this.percentageComplete >= 80 && this.percentageComplete <= 95) holder = "yellowish";
    if(this.percentageComplete >= 95 && this.percentageComplete <= 100) holder = "green";

    this.progressTracker.checkClass = 'checkmark__fill__' + holder; 
    this.progressTracker.circleClass = 'checkmark__circle__' + holder; 
    console.log('percent complete',this.percentageComplete);
    this.toggleLoader();
    // TODO: update the progress bar colors.
  }

  
}


// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/Models/BaseComponent.ts